/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountDeletionTasksSearchRequestOrderedBy
 */
export interface AccountDeletionTasksSearchRequestOrderedBy {
    /**
     * 
     * @type {string}
     * @memberof AccountDeletionTasksSearchRequestOrderedBy
     */
    property: AccountDeletionTasksSearchRequestOrderedByPropertyEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountDeletionTasksSearchRequestOrderedBy
     */
    direction: AccountDeletionTasksSearchRequestOrderedByDirectionEnum;
}


/**
 * @export
 */
export const AccountDeletionTasksSearchRequestOrderedByPropertyEnum = {
    CreationDateTime: 'creationDateTime',
    LastStatusChangeDateTime: 'lastStatusChangeDateTime'
} as const;
export type AccountDeletionTasksSearchRequestOrderedByPropertyEnum = typeof AccountDeletionTasksSearchRequestOrderedByPropertyEnum[keyof typeof AccountDeletionTasksSearchRequestOrderedByPropertyEnum];

/**
 * @export
 */
export const AccountDeletionTasksSearchRequestOrderedByDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type AccountDeletionTasksSearchRequestOrderedByDirectionEnum = typeof AccountDeletionTasksSearchRequestOrderedByDirectionEnum[keyof typeof AccountDeletionTasksSearchRequestOrderedByDirectionEnum];


/**
 * Check if a given object implements the AccountDeletionTasksSearchRequestOrderedBy interface.
 */
export function instanceOfAccountDeletionTasksSearchRequestOrderedBy(value: object): value is AccountDeletionTasksSearchRequestOrderedBy {
    if (!('property' in value) || value['property'] === undefined) return false;
    if (!('direction' in value) || value['direction'] === undefined) return false;
    return true;
}

export function AccountDeletionTasksSearchRequestOrderedByFromJSON(json: any): AccountDeletionTasksSearchRequestOrderedBy {
    return AccountDeletionTasksSearchRequestOrderedByFromJSONTyped(json, false);
}

export function AccountDeletionTasksSearchRequestOrderedByFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDeletionTasksSearchRequestOrderedBy {
    if (json == null) {
        return json;
    }
    return {
        
        'property': json['property'],
        'direction': json['direction'],
    };
}

export function AccountDeletionTasksSearchRequestOrderedByToJSON(value?: AccountDeletionTasksSearchRequestOrderedBy | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'property': value['property'],
        'direction': value['direction'],
    };
}

